import { initializeIcons as initIcons } from './officestarticons';
var DEFAULT_CDN_DOMAIN = 'res.cdn.office.net/officehub';
var iconsContainer = 'officestarticons';
export function initializeIcons(useLocalFiles, useFluentFont, cdnDomain) {
    if (useLocalFiles === void 0) { useLocalFiles = false; }
    if (useFluentFont === void 0) { useFluentFont = false; }
    if (cdnDomain === void 0) { cdnDomain = DEFAULT_CDN_DOMAIN; }
    initIcons(useLocalFiles
        ? process.env.PUBLIC_URL + "/fonts/"
        : "https://" + cdnDomain + "/" + iconsContainer + "/", useFluentFont);
}
//# sourceMappingURL=initializeIcons.js.map